import { Component } from '@angular/core';
import { PeerPoolDisciplineGridCellActions } from '../../models/peer-pool-discipline-grid-cell-actions.model';

@Component({
  standalone: false,
  selector: 'app-peer-pool-disciplines-actions-renderer',
  templateUrl: './peer-pool-disciplines-actions-renderer.component.html',
  styleUrls: ['./peer-pool-disciplines-actions-renderer.component.scss'],
})
export class PeerPoolDisciplinesTableActionsRendererComponent {
  params?: PeerPoolDisciplineGridCellActions;

  // gets called once before the renderer is used
  agInit(params: PeerPoolDisciplineGridCellActions): void {
    this.params = params;
  }

  editClick() {
    this.params?.onEditClick(this.params.data.id!);
  }

  deleteClick() {
    this.params?.onDeleteClick(this.params.data.id!);
  }
}
